// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vQGf6TAv064Bab0q{border-radius:1000px}.ynMDwmpGVEAiL7SO{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.rQyQRrFIiYC8CEwg{display:flex;flex-direction:column;justify-content:center;align-items:center}._QZ_HWUeIcgg7dx3{animation:vD2sXCTxHbM4WivB 3s infinite;animation-iteration-count:infinite}@keyframes vD2sXCTxHbM4WivB{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.TFFOMGmljEwg4XoL{color:#3e90c1}.TFFOMGmljEwg4XoL:hover{cursor:pointer}.BjaCqsRVOmoNLOYH{width:200px;margin-bottom:20px}.BjaCqsRVOmoNLOYH div{margin-bottom:5px}.XYeF17pzgSAEoYJe{margin-top:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `vQGf6TAv064Bab0q`,
	"text-truncate": `ynMDwmpGVEAiL7SO`,
	"shaquille": `rQyQRrFIiYC8CEwg`,
	"shimmer": `_QZ_HWUeIcgg7dx3`,
	"placeHolderShimmer": `vD2sXCTxHbM4WivB`,
	"eventName": `TFFOMGmljEwg4XoL`,
	"logDetailsfilters": `BjaCqsRVOmoNLOYH`,
	"paginatorWrapper": `XYeF17pzgSAEoYJe`
};
export default ___CSS_LOADER_EXPORT___;
